<ul class="nav nav-tabs">
  <!-- Loop through all the tabs I have on the same level and check which one is active -->
  <li *ngFor="let tab of tabs" (click)="selectTab(tab)" [class.active]="tab.active">
    <a href="" [ngClass]="tab.active ? 'nav-link active' : 'nav-link'" data-toggle="tab">{{tab.tabTitle}}</a>
  </li>
</ul>
<ng-content></ng-content>
